<div class="ex-user-access-selector-wrapper">
    <mat-form-field appearance="outline" class="form-field" [style.width]="285 | px2rem" (click)="togglePannel()" data-cy="ex-user-access-selector-pannel-toggle">
        <input matInput placeholder="Select Advertiser" readonly [value]="exUserAccessName">
        <i matSuffix class="rb rb-icon-arrow-{{pannelVisible ? 'up':'down'}}"
            style="color:rgba(0, 0, 0, 0.54);font-size: 24px;"></i>
    </mat-form-field>
    <div class="pannel" [hidden]="!pannelVisible">
        <app-search-inline  (keywordChange)="filterAdvertiserAndAgency($event)" data-cy="ex-user-access-selector-search"></app-search-inline>
        <div class="pannel-section">
            <section *ngFor="let adOrAgency of advertiserAndAgency">
                <div *ngIf="adOrAgency.isVisible" [attr.data-cy]="'ex-user-access-selector-' + (adOrAgency.isAgency ? 'agency' : 'advertiser') + '-item-' + adOrAgency.id"
                    style="height: 28px;line-height: 28px;">
                    <mat-checkbox class="example-margin" color="primary" [checked]="adOrAgency.selected"
                        (change)="handleAdOrAgencyClick($event.checked, adOrAgency)">
                        <span style="color:#6B6167">{{adOrAgency.name}}</span>
                    </mat-checkbox>
                </div>
                <div>
                    <ul>
                        <li *ngFor="let ad of adOrAgency.children" style="max-height: 28px;line-height: 28px;" [attr.data-cy]="'ex-user-access-selector-advertiser-item-' + ad.id">
                            <mat-checkbox color="primary" [checked]="ad.selected"
                                (change)="handleAdClick($event.checked, ad)" *ngIf="ad.isVisible"
                                [disabled]="adOrAgency.selected">
                                {{ad.name}}
                            </mat-checkbox>
                        </li>
                    </ul>
                </div>
            </section>
        </div>
    </div>
</div>